import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["calendar", "checkbox"]

  connect() {
    const showCalendar = localStorage.getItem("showBoardCalendar") === "true"

    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = showCalendar
    }

    this.toggleCalendar(showCalendar)
  }

  checkboxClicked(event) {
    const showCalendar = event.target.checked

    localStorage.setItem("showBoardCalendar", showCalendar)

    this.toggleCalendar(showCalendar)
  }

  toggleCalendar(show) {
    if (this.hasCalendarTarget) {
      if (show) {
        this.calendarTarget.classList.remove("hidden")
      } else {
        this.calendarTarget.classList.add("hidden")
      }
    }
  }
}
